export default __webpack_public_path__ + "static/media/icon-pagination-next-disable.925773f0.svg";